export const applicationStatusDropdownController = ($scope, $document) => {
  $scope.openApplicationStatusDropdown = event => {
    event.stopPropagation()
  }

  $scope.statusColor = color => {
    if (color) {
      return {
        background: color,
      }
    }
  }

  $scope.selectApplicationStatus = selectedValue => {
    var elements = $document[0].querySelectorAll('.clickedSelected')
    ;[].forEach.call(elements, element => {
      element.classList.remove('clickedSelected')
    })
    let status = $document[0].querySelector('#status' + selectedValue.id)
      .firstElementChild
    status.classList.add('clickedSelected')
    $scope.selectedApplicationStatus = selectedValue
  }

  $scope.closeApplicationDropdown = () => {
    $scope.gridOptions.api.deselectAll()
    $('#applicationStatusDropdownList').hide()
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/application/application-status-dropdown/application-status-dropdown.ctrl.js